import React, { useEffect, useRef } from "react";
import { Image, Modal, Row } from "react-bootstrap";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants";
import { useState } from "react";
import useNote from "../hooks/useNote";
import NoteEditNote from "./NoteEditNote";

const NoteCardSingle = ({ note, name }) => {
  
const [showImage, setShowImage] = useState(false);
const {isOwnNote} = useNote();
const [expanded, setExpanded] = useState(false);
const [isOverflowing, setIsOverflowing] = useState(false);
const contentRef = useRef();

useEffect(() => {
  const el = contentRef.current;
  if (!el) return;

  el.classList.add("measure-full");
  el.classList.remove("collapsed");

  requestAnimationFrame(() => {
    const fullHeight = el.scrollHeight;

    el.classList.remove("measure-full");
    el.classList.add("collapsed");

    requestAnimationFrame(() => {
      const clampedHeight = el.clientHeight;

      if (fullHeight > clampedHeight + 1) {
        setIsOverflowing(true);
      } else {
        setIsOverflowing(false);
      }

      // console.log("fullHeight:", fullHeight);
      // console.log("clampedHeight:", clampedHeight);
    });
  });
}, [note.text]);




const [showEditModal, setShowEditModal] = useState(false);
const handleEditClick = () => {
  setShowEditModal(true);
};  

const isOfflineImage =
  note.image &&
  typeof note.image === "object" &&
  note.image.offline === true;

const imageSrc = isOfflineImage
  ? note.image.blob
      ? URL.createObjectURL(note.image.blob)
      : null
  : note.image
      ? constants.BASE_URL + note.image
      : null;


  return (
    <Row className="pb-2" xs={12} md={12} lg={12}>
      <div className="note-container">
        <div className="note-info d-flex justify-content-between align-items-center">
          <div className="note-info-left d-flex align-items-center p-1">
            <div className="note-created_by">{note.manpower_name}</div>
          </div>
          <div className="note-info-right d-flex align-items-center p-1">
            <div className="note-created_at">
              {note.created_at && !isNaN(new Date(note.created_at))
                  ? new Date(note.created_at).toLocaleString("hu-HU", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false
                    }).replace(",", "")
                  : 'Offline megjegyzés'}
            </div>
            {isOwnNote(note) && <FontAwesomeIcon className="icon ms-1 edit-note-icon" icon={"cog"} onClick={handleEditClick} />}
          </div>
        </div>
        <div className="note-content">
            <div ref={contentRef} className={`note-content-inner ${expanded ? "expanded" : "collapsed"}`} >
              {note.text}
            </div>
            {isOverflowing && (
              <button className="toggle-button" onClick={() => setExpanded(!expanded)}>
                {expanded ? "KEVESEBB" : "TÖBB"}
              </button>
            )}


            {/* Bélyegkép */}
            {imageSrc && (
              <div className="note-image pt-2">
                <Image
                  src={imageSrc}
                  thumbnail
                  onClick={() => setShowImage(true)}
                  className="img-thumbnail clickable"
                />
              </div>
            )}
        </div>
      </div>
          {/* Modal a teljes képre */}
          <Modal className="note-image-modal" show={showImage} onHide={() => setShowImage(false)} centered size="lg" backdrop="static" keyboard={false}>
            <Modal.Header className="text-end"><FontAwesomeIcon className="icon" icon={"xmark"} onClick={() => setShowImage(false)} /></Modal.Header>
            <Modal.Body className="text-center">
            {imageSrc && (
              <Image
                src={imageSrc}
                fluid
                className="zoomable-image"
              />
            )}
            </Modal.Body>
          </Modal>

          {/* Új modal hozzáadása a szerkesztéshez */}
          <Modal className="note-edit-node-modal" show={showEditModal} onHide={() => setShowEditModal(false)} centered size="lg" backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
              <Modal.Title><FontAwesomeIcon className="icon ms-1 edit-note-icon" icon={"cog"} /> Szerkesztés</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <NoteEditNote name={name} note={note} showEditModal={showEditModal} setShowEditModal={setShowEditModal} />
            </Modal.Body>
          </Modal>
    </Row>
  );
};

export default NoteCardSingle;
